import { useMechanicAuth } from '../MechanicAuthContext';
import InvoiceScanner from '../../shared/InvoiceScanner';

const MechanicExpensesPage = () => {
  const { token } = useMechanicAuth();
  return <InvoiceScanner token={token} title="Depenses atelier" />;
};

export default MechanicExpensesPage;
